import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScBalanceContainer = styled.div`
  display: grid;
  gap: 16px;

  @media (${device.mobileS}) {
    margin-bottom: 48px;
  }

  & .title {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.02em;
    color: ${({ theme }) => theme.blackColor};
    text-transform: uppercase;

    @media (${device.mobileS}) {
      font-size: 20px;
      line-height: 26px;
      color: ${({ theme }) => theme.whiteColor};
    }
  }
`;

export const ScInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 16px;
  margin-top: 4px;

  & > svg {
    width: 20px;
    height: 20px;
    object-fit: contain;
    flex-shrink: 0;

    path {
      fill: ${({ theme }) => theme.blackColor};

      @media (${device.mobileS}) {
        fill: ${({ theme }) => theme.whiteColor};
      }
    }
  }

  span {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    color: ${({ theme }) => theme.blackColor};

    @media (${device.mobileS}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }
`;

export const ScBalanceRows = styled.div`
  display: grid;
  gap: 8px;
  padding: 0 16px;
`;

export const ScBalanceRow = styled.p`
  display: flex;
  justify-content: space-between;

  & span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.01em;
    color: #000000;

    @media (${device.mobileS}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }
`;
